import { render, staticRenderFns } from "./PermissionMatrixDownloads.vue?vue&type=template&id=134412b2"
import script from "./PermissionMatrixDownloads.vue?vue&type=script&lang=js"
export * from "./PermissionMatrixDownloads.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports